import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-caee8fa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import TipsQualityBox from '@/components/video-diagnostic/TipsQualityBox.vue'
import { Stage, QualityScore } from '@/types/enums/video-diagnostic.enum'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface PoorQualityTestEmits {
  (e: 'nextStage'): void
  (e: 'updateToggle'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PoorQuality',
  props: {
  stage: {
    type: Number,
    required: true,
  },
  totalQualityScore: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "updateToggle"],
  setup(__props, { emit: __emit }) {

const props = __props
const i18n = useI18n()

const emit = __emit

const qualityScore = computed(() =>
  props.totalQualityScore === QualityScore.Suboptimal ? 'is-poor' : 'is-bad',
)
const qualityDetail = computed(() =>
  props.totalQualityScore === QualityScore.Suboptimal ? 'suboptimal' : 'degraded',
)
const qualityDetail2 = computed(() =>
  props.totalQualityScore === QualityScore.Suboptimal ? 'could be better' : 'will be poor',
)

const displayQualityScore = computed(() => {
  const color = qualityScore.value === 'is-poor' ? 'text-yellow-500' : 'text-red-500'
  return `<span class="${color}">${i18n.t(
    `video-diagnostic.poor-quality-status.${qualityScore.value}`,
  )}</span>`
})

const displayQualityDetailcolore = computed(() => {
  const color = qualityDetail.value === 'suboptimal' ? 'text-yellow-500' : 'text-red-500'
  return `<strong class="${color}">${i18n.t(
    `video-diagnostic.poor-quality-detail-status.${qualityDetail.value}`,
  )}</strong>`
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).QUALITY,
    class: _normalizeClass(
      __props.stage === _unref(Stage).QUALITY || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, [
          _createVNode(_component_SvgIcon, {
            class: "icon-container",
            icon: __props.totalQualityScore === _unref(QualityScore).Suboptimal ? 'warning-sign' : 'error-sign',
            "inherit-fill": true,
            height: "24"
          }, null, 8, ["icon"]),
          _createElementVNode("span", {
            innerHTML: _ctx.$t('video-diagnostic.poor-quality', { qualityScore: displayQualityScore.value })
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            innerHTML: 
              _ctx.$tc('video-diagnostic.poor-quality-detail', {
                qualityDetail: displayQualityDetailcolore.value,
                qualityDetail2: qualityDetail2.value,
              })
            
          }, null, 8, _hoisted_5),
          _createVNode(_component_SvgIcon, {
            icon: 'info',
            "inherit-fill": true,
            height: "16",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('updateToggle')))
          })
        ])
      ]),
      _createVNode(TipsQualityBox),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "flex"])
        }, [
          _createElementVNode("button", {
            class: "text-white border-2 rounded-md border-white bg-primary-color py-2 px-4",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('nextStage')))
          }, _toDisplayString(_ctx.$t('video-diagnostic.ok')), 1),
          _createElementVNode("button", {
            class: "skip-button rounded-md py-2 px-4 ml-4",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('nextStage')))
          }, _toDisplayString(_ctx.$t('video-diagnostic.skip-for-now')), 1)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})